import axios from 'axios';
import errorMessage from 'Store/actions/errorMessage';
import qs from 'query-string';
import { navigateWithParams, getSearchParams } from 'Utils/horseRacingRouteHelper';
import { SET_SELECTED_PROBABILITIES_HIPPODROME, GET_HORSE_RACE_PROBABILITIES, GET_HORSE_RACE_PROBABILITIES_FAILURE, GET_HORSE_RACE_PROBABILITIES_SUCCESS, GET_HORSE_RACE_PROBABILITIES_HIPPODROMES, GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_FAILURE, GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_SUCCESS, SET_SELECTED_HORSE_RACE_PROBABILITIES } from 'Store/constants';
import { probablesMapper, hippodromesMapper, findInHippodromeByKey } from 'Utils/horseRacesNameMapper';
import { catchTJKError } from 'Utils/catchTJKError';
import ProjectConfig from 'ProjectConfig';

export const getProbabilities = (cardId, isLoading) => async dispatch => {
  try {
    dispatch({
      type: GET_HORSE_RACE_PROBABILITIES,
      payload: { isLoading: isLoading }
    });

    const search = getSearchParams();

    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/probabilities/' + cardId;
    const res = await axios.get(apiUrl);

    const payload = probablesMapper(res.data.body);

    catchTJKError(res.data);

    let _slctdleg = null;
    let _selectedLegNo = null;
    
    if (search.ln) {
      _slctdleg = payload?.legList?.find(e => e.raceNo === search.ln + '');
      _selectedLegNo = search.ln;
    }

    if (!_slctdleg) {
      _selectedLegNo =  payload.currentRaceNumber || '1'; // searchte varsa o, yoksa payloaddaki crn, oda yoksa ilk item
      _slctdleg = payload?.legList?.find(e => e.raceNo === _selectedLegNo + '');
    }

    dispatch(setSelectedPropbabilitiesLeg(_slctdleg));

    dispatch({
      type: GET_HORSE_RACE_PROBABILITIES_SUCCESS,
      payload: payload?.legList
    });

    const _data = {
      hpdm: getSearchParams().hpdm,
      ln: _selectedLegNo,
      tarih: getSearchParams().tarih,
    };
  
    navigateWithParams({ type: 'replace', search: qs.stringify(_data) });

  } catch (e) {
  
    dispatch({
      type: GET_HORSE_RACE_PROBABILITIES_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setSelectedPropbabilitiesLeg = leg => async dispatch => {
  dispatch({
    type: SET_SELECTED_HORSE_RACE_PROBABILITIES,
    payload: leg
  });
};

export const getProbablesHippodromes = (raceDate, defaultHippodromeKey) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_HORSE_RACE_PROBABILITIES_HIPPODROMES,
    });
    const now = new Date();
    const nowHours = now.toISOString().split('T')[1];
    const date = new Date(`${raceDate}T${nowHours}`)?.getTime();

    const apiUrl = ProjectConfig.API_GATEWAY + '/mobile/tjk/hippodromes/probability';
    const res = await axios.get(apiUrl, { params: { raceDate: date } });
  
    const payload = hippodromesMapper(res.data.body);

    catchTJKError(res.data);

    const foundedFromParams = payload.find(e => e.key === defaultHippodromeKey);
    const defaultSelected = foundedFromParams || payload.find(e => e.isSelected) || payload[0];
    
    if (!defaultSelected) {
      const _data = {
        tarih: raceDate,
      };

      navigateWithParams({ type: 'replace', search: qs.stringify(_data) });

      //hipodrom bulunamadıysa leg datası da temizlenmenli
      dispatch(setSelectedPropbabilitiesLeg({}));
      dispatch({
        type: GET_HORSE_RACE_PROBABILITIES_SUCCESS,
        payload: []
      });
    } else {
      const allHippodromes = getState().horseRacing.allHippodromes;
      const _data = {
        hpdm: findInHippodromeByKey(defaultSelected?.key, allHippodromes.data).location || '',
        ln: getSearchParams().ln,
        tarih: raceDate,
      };
      navigateWithParams({ type: 'replace', search: qs.stringify(_data) });
    }

    dispatch(setSelectedProbabilitiesHippodrome(defaultSelected));
    
    dispatch({
      type: GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_SUCCESS,
      payload: payload
    });
  } catch (e) {
    dispatch({
      type: GET_HORSE_RACE_PROBABILITIES_HIPPODROMES_FAILURE,
      payload: e.response?.data || (e.message ? e : errorMessage),
    });
  }
};

export const setSelectedProbabilitiesHippodrome = hipp => async dispatch => {
  dispatch({
    type: SET_SELECTED_PROBABILITIES_HIPPODROME,
    payload: hipp
  });
};
